import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDataProvider } from "../../context/DataContext";
import BackdropLoading from "../display/BackdropLoading";
import { useAuth } from "../../hooks/useAuth";
import AdminPanel from "../../Admin/AdminPanel";

const referenceImage = "https://firebasestorage.googleapis.com/v0/b/ordertakingsystem-29f8f.appspot.com/o/uploads%2F-NPfaW1claeJv21hXmE-%2F-NPgQ9f1gFYphHf5Io7c.jpg?alt=media&token=1d06fd41-411e-4bf0-9ae9-59b56ad31e9c";

function CategoryWithImage() {
  const { data } = useDataProvider();
  const [categories, setCategories] = useState([]);
  let { branch } = useParams();
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleCategoryDetail = (categoryIndex) => {
    navigate(`/${branch}/${categoryIndex}`);
  };

  const getCategories = () => {
    let categories = [];
    data.map((item) => {
      categories.push({categoryName: item.categoryName , categoryThumbnailUrl: item.categoryThumbnailUrl});
    });
    setCategories(categories);
  };

  useEffect(() => {
    getCategories();
  }, [data]);
  
  return ( data.length > 0 ? 
    <Grid container>
      {isAdmin && <AdminPanel />}
      {categories.map((category, index) => {
        return (
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} padding={1}>
            <Box sx={{ position: "relative" }}>
              <div
                onClick={() => handleCategoryDetail(index)}
              >
                <img
                  src={(category.categoryThumbnailUrl && category.categoryThumbnailUrl !== " ") ? category.categoryThumbnailUrl : referenceImage}
                  style={{
                    objectFit: "cover",
                  }}
                  className="photo"
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    height: "50%",
                    width: "100%",
                    paddingX: 1,
                    display: "flex",
                    borderRadius: ".25rem",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgb(2,0,36)",
                    background:
                      "linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(109,109,111,0.7147059507396709) 75%, rgba(255,255,255,0) 100%)",
                  }}
                >
                  <Typography color="whitesmoke" mt={3} textAlign="center">
                    {category.categoryName}
                  </Typography>
                </Box>
              </div>
            </Box>
          </Grid>
        );
      })}
    </Grid>
    :
    <BackdropLoading loading={true} />
  );
}

export default CategoryWithImage;
